const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0C3.14497 0 0 3.14497 0 7C0 10.855 3.14497 14 7 14C10.855 14 14 10.855 14 7C14 3.14497 10.855 0 7 0ZM7.96397 9.53682L7.30455 9.79044L8.06542 5.83391C8.11615 5.63101 8.0147 5.42811 7.86253 5.27595C7.71035 5.1745 7.45672 5.12377 7.30456 5.22522L5.88426 6.03681C5.63064 6.18898 5.52919 6.49334 5.68136 6.74696C5.83353 7.00057 6.13789 7.10203 6.39151 6.94986L6.79731 6.69624L6.03644 10.5005C5.98571 10.7034 6.08716 10.9063 6.23934 11.0078C6.34079 11.1092 6.44223 11.1092 6.59441 11.1092C6.64513 11.1092 6.74658 11.1092 6.79731 11.0585L8.36977 10.3991C8.62339 10.2976 8.77557 9.94253 8.62339 9.68891C8.52194 9.53674 8.21759 9.38456 7.96397 9.53674V9.53682ZM8.11619 3.95555C7.96403 4.057 7.76113 4.15845 7.55823 4.15845C7.35534 4.15845 7.20316 4.10772 7.00026 3.95555C6.89881 3.80339 6.79736 3.60047 6.79736 3.39758C6.79736 3.19469 6.84809 2.99179 7.00026 2.83962C7.15243 2.73817 7.35533 2.63672 7.55823 2.63672C7.76112 2.63672 7.96402 2.68744 8.11619 2.83962C8.21764 2.99178 8.31909 3.19469 8.31909 3.39758C8.31909 3.60047 8.26837 3.80338 8.11619 3.95555Z",
    fill: "#E9DFCE",
    fillOpacity: 0.7,
    style: {
      fill: "#E9DFCE",
      fill: "color(display-p3 0.9137 0.8745 0.8078)",
      fillOpacity: 0.7
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.6d0dfd439a68df446fbe837fbcfbee82.svg";
export { ForwardRef as ReactComponent };